import {ERequestType} from 'shared/types/requests';
import {performRequest, showMessageFromResponse} from 'shared/utils';

import {checkReadFlag} from '../lib';
import {NEWS_ENTITY_NAME} from '../model/constants';
import {IFetchNewsParams} from '../model/types';

const fetchNews = (userId: number) => performRequest({
    url: `/${NEWS_ENTITY_NAME}?search=`,
    method: ERequestType.GET,
    headers: {
        userId,
    },
});

export const fetchHasUnreadRequests = () => performRequest({
    url: 'requests-requirement/unread-messages',
    method: ERequestType.GET,
});

export const loadListOfNews = async ({
    userId,
    newsRef,
    setNeedRead,
    shouldShowErrorToUser = false,
}: IFetchNewsParams) => {
    try {
        const {data} = await fetchNews(userId);
        checkReadFlag(data, userId, newsRef, setNeedRead);
    } catch (e) {
        if (shouldShowErrorToUser) {
            console.error(e);
            showMessageFromResponse({response: e.response, isError: true});
        }
    }
};
